module.exports = __webpack_public_path__ + "static/media/x-mark-white.90fd1561.svg";